<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="">
                    <FormRow inline>
                        <LazyCurrencySelector :currencies="['USD', 'ILS', 'CAD']"/>
                    </FormRow>
                    <AmountSelector/>
                    <ErrorLabel field="amount" />
                    <TransactionFee />
                </FormSection>
                <FormSection title="">
                  <DonationFrequency />
                </FormSection>
                <FormSection title="Your Details">
                    <FormRow inline>
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                      <Consent privacy="https://www.ouisrael.org/privacy-policy/"/>
                  </FormRow>                     
                </FormSection>
                <FormSection title="Billing Information">
                    <DonorAddress />
                </FormSection>
                <FormSection title="Dedication and Designation">
                  <InHonorOf />
                </FormSection>
                <FormSection title="Payment Information" last>
                  <FormRow>
                    <Receipt />
                  </FormRow>
                    <FormRow inline>
                        <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton showAmount btnText="Donate"/>
                <br/>
                <p class="other-means">
                  For other means of donating - please contact us by:<br/>
                  <strong>TEL:</strong> (02) 560-9100<br/>
                  <strong>FAX:</strong> (02) 566-0156<br/>
                  <strong>EMAIL:</strong> <a href="mailto:ABerman@ouisrael.org">ABerman@ouisrael.org</a>
                </p>
            </PaymentForm>
        </div>
    </div>
</div>
</template>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
.fee-total {
  margin-bottom: 0;
  justify-content: space-between;
}
.other-means {
  font-size: 14px;
  line-height: 1.6;
}
::v-deep .styled-radio--ou-donation.styled-radio .radio-part {
  min-width: 23%;
  max-width: 23%;
  &:nth-child(6n) {
    padding-right: 10px;
  }
}
.control-label {
  font-size: 14px;
  color: #222;
}
</style>

